import axios from "axios";
import { FIELDDATA_API_BASE_PATH } from "../fieldDataApi";

// Use the existing authenticated server proxy unless a legacy endpoint is configured.
const baseURL = (
  process.env.REACT_APP_BASE_URL_FIELD_DATA || FIELDDATA_API_BASE_PATH
).replace(/\/+$/, "");
const apiKey = process.env.REACT_APP_API_KEY;

export const buildDigitalTwinDataUrl = (path) =>
  `${baseURL}/${String(path).replace(/^\/+/, "")}`;

export const getDigitalTwinDataHeaders = () =>
  apiKey ? { "X-API-Key": apiKey } : {};

const fieldDataClient = axios.create({
  baseURL,
  timeout: 30000,
  ...(apiKey ? { headers: getDigitalTwinDataHeaders() } : {}),
});

export default fieldDataClient;
